export class StringUtil {
  public static split(str: string, ch: string) {
    if (str === undefined || str === null) return [] as string[];
    return str.split(ch);
  }
}
